import { Undo2, Redo2 } from 'lucide-react'
import type { DesignHistory } from '@/hooks/useDesignHistory'

const isMac = typeof navigator !== 'undefined' && /Mac|iP(hone|ad|od)/.test(navigator.platform)
const UNDO_HINT = isMac ? '⌘Z' : 'Ctrl+Z'
const REDO_HINT = isMac ? '⌘⇧Z' : 'Ctrl+Y'

// The undo/redo button pair every one-document designer toolbar shares
// (visual, dashboard, schema, business area). Pair with useDesignHistory.
export function UndoRedoButtons({ history }: { history: DesignHistory }) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
      <button
        type="button"
        className="btn btn-ghost btn-sm"
        onClick={history.undo}
        disabled={!history.canUndo}
        title={`Undo (${UNDO_HINT})`}
        style={{ padding: '4px 7px', opacity: history.canUndo ? 1 : 0.35 }}
      >
        <Undo2 size={15} />
      </button>
      <button
        type="button"
        className="btn btn-ghost btn-sm"
        onClick={history.redo}
        disabled={!history.canRedo}
        title={`Redo (${REDO_HINT})`}
        style={{ padding: '4px 7px', opacity: history.canRedo ? 1 : 0.35 }}
      >
        <Redo2 size={15} />
      </button>
    </div>
  )
}

export default UndoRedoButtons
